import React, {Component} from 'react';
import Datetime from 'react-datetime';
import FormField from './form-field';
import {date_format} from '../../../utils/constants';

export default class DateInput extends Component {


    render() {
        const {
            label,
            meta,
            showError,
            input,
            time = false,
            required,
            isValidDate = null,
            ...restprops
        } = this.props;
        let value = input.value;

        return (
            <FormField label={label} meta={meta} showError={showError} required={required}>
                <Datetime onChange={(value) => input.onChange && input.onChange(value)} {...restprops} value={value}
                          dateFormat={date_format} timeFormat={time}
                          locale={'lt'}
                          isValidDate={isValidDate}/>
            </FormField>
        );
    }
}





// WEBPACK FOOTER //
// ./src/js/components/form/fields/date-field.jsx